module.exports = __webpack_public_path__ + "img/value.cf595763.svg";